import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common'
import { z } from 'zod'

export const GroupsSearchParamsSchema = z
  .object({
    q: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type GroupsSearchParams = z.infer<typeof GroupsSearchParamsSchema>

export const GroupSearchResultModelSchema = z.object({
  id: z.number(),
  name: z.string(),
})

export type GroupSearchResultModel = z.infer<
  typeof GroupSearchResultModelSchema
>

export const GroupsSearchResultSchema = z
  .object({
    data: z.array(GroupSearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type GroupsSearchResult = z.infer<typeof GroupsSearchResultSchema>
